export { useVerticalNavMenuGroup as default };
import * as vue_composition_api from '@vue/composition-api';
import store from '@/store';
import core_layouts_utils from '@core/layouts/utils';



function useVerticalNavMenuGroup(item) {
  // ------------------------------------------------
  // isVerticalMenuCollapsed
  // ------------------------------------------------
  const isVerticalMenuCollapsed = vue_composition_api.computed(() => store.state.verticalMenu.isVerticalMenuCollapsed);
  vue_composition_api.watch(isVerticalMenuCollapsed, val => {
    /* eslint-disable no-use-before-define */
    // * Handles case if routing is done outside of vertical menu
    // i.e. From Customizer Collapse or Using Link
    if (!isMouseHovered.value) {
      if (val) isOpen.value = false;else if (!val && isActive.value) isOpen.value = true;
    }
    /* eslint-enable */
  });

  // ------------------------------------------------
  // isMouseHovered
  // ------------------------------------------------
  const isMouseHovered = vue_composition_api.inject('isMouseHovered');

  // Collapse menu when menu is collapsed and show on open
  vue_composition_api.watch(isMouseHovered, val => {
    if (isVerticalMenuCollapsed.value) {
      // * we have used `val && val && isActive.value` to only open active menu on mouseEnter and close all menu on mouseLeave
      // * If we don't use `isActive.value` with `val` it can open other groups which are not active as well
      isOpen.value = val && isActive.value;
    }
  });

  // ------------------------------------------------
  // openGroups
  // ------------------------------------------------
  const openGroups = vue_composition_api.inject('openGroups');

  // Collapse other groups if one group is opened
  vue_composition_api.watch(openGroups, currentOpenGroups => {
    const clickedGroup = currentOpenGroups[currentOpenGroups.length - 1];

    // If current group is not clicked group or current group is not active => Proceed with closing it
    if (clickedGroup !== item.title && !isActive.value) {
      // If clicked group is not child of current group
      if (!doesHaveChild(clickedGroup)) isOpen.value = false;
    }
  });

  // ------------------------------------------------
  // isOpen
  // ------------------------------------------------
  const isOpen = vue_composition_api.ref(false);
  vue_composition_api.watch(isOpen, val => {
    // if group is opened push it to the array
    if (val) openGroups.value.push(item.title);
  });
  const updateGroupOpen = val => {
    isOpen.value = val;
  };

  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = vue_composition_api.ref(false);
  vue_composition_api.watch(isActive, val => {
    /*
      If menu is collapsed and not hovered(optional) then don't open group
    */
    if (val) {
      if (!isVerticalMenuCollapsed.value) isOpen.value = val;
    } else {
      isOpen.value = val;
    }
  });
  const updateIsActive = () => {
    isActive.value = core_layouts_utils.isNavGroupActive(item.children);
  };

  // ------------------------------------------------
  // Other Methods
  // ------------------------------------------------

  const doesHaveChild = title => item.children.some(child => child.title === title);
  return {
    isOpen,
    isActive,
    updateGroupOpen,
    openGroups,
    isMouseHovered,
    updateIsActive
  };
}

